import Vue from 'vue'
import router from './router'
import store from './store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { ACCESS_TOKEN, USER_HALL_INFO, ACCESS_SECRET } from '@/store/mutation-types'
import { generateIndexRouter, generateAnonRouters } from "@/utils/util"

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login', '/user/register'] // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  NProgress.start() // start progress bar
  console.log('location.hash', location.hash)
  // 从别的系统带参跳转，保存参数
  if (location.hash && !localStorage.getItem('hash')) {
    localStorage.setItem('hash', location.pathname + location.hash)
  }

  console.log('router to', to.path, to.params, to.query)
  if (to.path.startsWith('/anon')) {
    console.log('to anon page', to.path)
    if (store.getters.anonPages === null) {
      store.dispatch('loadAnonList').then(res => {
        const anonPages = res.result
        if (anonPages == null) {
          return
        }
        let constRoutes = [];
        constRoutes = generateAnonRouters(anonPages);
        router.addRoutes(constRoutes)
        console.log(to)
        next({ path: to.fullPath })
        // 添加主界面路由
      })
    } else {
      next()
    }
  }
  else {
    const token = Vue.ls.get(ACCESS_TOKEN)
    const secret = Vue.ls.get(ACCESS_SECRET)
    const hallInfo = Vue.ls.get(USER_HALL_INFO)
    if (token && secret) { 
      // 从别的系统带参跳转，待有用户信息后增加参数
      const hash = localStorage.getItem('hash')
      if (hash) {
        console.log('hash---', hash)
        localStorage.removeItem('hash')
        window.location.href = window.location.origin + hash
      }
      console.log('hallInfo', hallInfo, store.getters.hallInfo)
      if (!store.getters.userInfo || !store.getters.hallInfo) {
        let tokenInfo = { token,secret }
        await store.dispatch('tokenLogin', tokenInfo).then(() => {          
        }).catch(() => {
          store.dispatch('Logout').then(() => {
            next({ path: '/login', query: { redirect: to.fullPath } })
          })
        })
        await store.dispatch('LoadHallInfo').then(res => {
        }).catch(() => {
          store.dispatch('Logout').then(() => {
            next({ path: '/login', query: { redirect: to.fullPath } })
          })
        })
        if (to.path == '/') {
          window.history.pushState(null, '', '/subApplication/GovernmentGuideWeb')
          next('/subApplication/GovernmentGuideWeb')
        }
        else {
          next()
        }
      }
      else {
        next()
      }
    } else if (to.path === '/login') {
      next()
    } else {
      if (whiteList.indexOf(to.path) !== -1) {
        // 在免登录白名单，直接进入
        next()
      } else {
        next({ path: '/login', query: to.query })
        NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
      }
    }
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})
